import React from "react";
import "./Features.css";

const Features = () => {
  const features = [
    {
      icon: "🏪",
      title: "Marketplace Intégré",
      description:
        "Parcourez et publiez des annonces pour tous types de produits avicoles avec des filtres avancés et une recherche intelligente.",
    },
    {
      icon: "💬",
      title: "Chat en Temps Réel",
      description:
        "Communiquez directement avec les vendeurs et acheteurs via un système de messagerie instantanée sécurisé.",
    },
    {
      icon: "📱",
      title: "Interface Intuitive",
      description:
        "Une application Flutter moderne avec une interface utilisateur soignée et des performances optimisées.",
    },
    {
      icon: "🔒",
      title: "Sécurité Garantie",
      description:
        "Authentification Firebase, transactions sécurisées et protection des données personnelles.",
    },
    {
      icon: "📊",
      title: "Tableau de Bord",
      description:
        "Suivez vos ventes, vos achats et vos statistiques avec un tableau de bord complet et détaillé.",
    },
    {
      icon: "⭐",
      title: "Système d'Avis",
      description:
        "Évaluez et consultez les avis pour faire confiance et être crédible dans vos transactions.",
    },
  ];

  return (
    <section id="fonctionnalites" className="section section--light">
      <div className="container">
        <div className="features__header text-center mb-5">
          <h2 className="features__title animate-fade-in-up">
            Fonctionnalités Principales
          </h2>
          <p className="features__subtitle animate-fade-in-up">
            Découvrez toutes les fonctionnalités qui font de Chiesugu la
            référence pour la vente de produits avicoles au Mali.
          </p>
        </div>

        <div className="grid grid--3">
          {features.map((feature, index) => (
            <div
              key={index}
              className="card features__card animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="features__icon">{feature.icon}</div>
              <h3 className="features__card-title">{feature.title}</h3>
              <p className="features__card-description">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
